import { Component, Input, OnInit } from '@angular/core';
import { isPedidoSetorGepExpedicao } from '../pedido-setor-gep';

interface Config {
    isExpedicao: boolean;
}

@Component({
    selector: 'sgt-pedido-setor-gep-badge',
    templateUrl: './pedido-setor-gep-badge.component.html',
    styleUrls: ['./pedido-setor-gep-badge.component.less']
})
export class PedidoSetorGepBadgeComponent implements OnInit {
    config: Config;

    @Input() setorGep: number;

    // Expedição
    @Input() dataInicioExpedicao: Date;
    @Input() dataTerminoExpedicao: Date;
    @Input() previsaoSeparacaoExpedicaoDias: number;

    ngOnInit(): void {
        this.createConfig();
    }

    private createConfig() {
        this.config = {
            isExpedicao: isPedidoSetorGepExpedicao(this.setorGep)
        };
    }
}
